class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quantityButtons = document.querySelectorAll('[data-quantity-button]');
    this.quantityInput = document.querySelector('input[name="quantity"]');

    this.handleQuantity = this.handleQuantity.bind(this);

    this.quantityButtons.forEach(button => {
      button.addEventListener('click', this.handleQuantity);
    })
  }

  disconnectedCallback() {
    this.quantityButtons.forEach(button => {
      button.removeEventListener('click', this.handleQuantity);
    })
  }

  handleQuantity(event) {
    const button = event.currentTarget;
    let updatedQuantity = Number(this.quantityInput.value);

    if (button.dataset.quantityButton === "minus") {
      updatedQuantity = Math.max(0, updatedQuantity - 1);
    } else if (button.dataset.quantityButton === "plus") {
      updatedQuantity += 1;
    }

    this.quantityInput.value = updatedQuantity;
  }
}

customElements.define('quantity-selector', QuantitySelector);
